import BomCostBox from './Bom/BomCostBox';
import MaterialBomCompareBox from './Bom/MaterialBomCompareBox';
import ProductBomBox from './Bom/ProductBomBox';
import NameBox from './Common/NameBox';
import SearchBox from './Common/SearchBox';
import SidemenuBox from './Common/SidemenuBox';
import ConveyorSketchGeneraror from './Machine/ConveyorSketchGeneraror';
import AllMaterialUsageCard from './Material/AllMaterialUsageCard';
import BoxPreferMaterial from './Material/BoxPreferMaterial';
import BoxRemainingMaterial from './Material/BoxRemainingMaterial';
import MaterialQuantityDisplay from './Material/MaterialQuantityDisplay';
import MaterialSourceBox from './Material/MaterialSourceBox';
import MaterialStockTab from './Material/MaterialStockTab';
import MaterialTransactionTab from './Material/MaterialTransactionTab';
import MaterialUsageBox from './Material/MaterialUsageBox';
import BoxAllMOMeasurementVariableBySteps from './MMS/BoxAllMOMeasurementVariableBySteps';
import BoxResultingFunction from './MMS/BoxResultingFunction';
import CommentBox from './MMS/CommentBox';
import InfoManufacturingOrder from './MMS/InfoManufacturingOrderBox';
import ManufacturingTransactionBox from './MMS/ManufacTransactionBox';
import MaterialMergingDisplay from './MMS/MaterialMergingDisplay';
import MeasurementVariableListBox from './MMS/MeasurementVariableListBox';
import OneMeasurementVariableBox from './MMS/OneMeasurementVariableBox';
import ProcessHandleProductOnlyControlBox from './MMS/ProcessHandleProductOnlyControlBox';
import ReportMaterialUsageTableRowElement from './MMS/ReportMaterialUsageTableRowElement';
import BoxDetailProcess from './Process/BoxDetailProcess';
import MaterialSplittingProcessActionContainerBox from './Process/MaterialSplittingProcessActionContainerBox';
import ProcessActionContainerBox from './Process/ProcessActionContainerBox';
import ProcessControlBox from './Process/ProcessControlBox';
import ProcessDetailBox from './Process/ProcessDetailBox';
import ProcessInfoBox from './Process/ProcessInfoBox';
import ProcessNoInfoBox from './Process/ProcessNoInfoBox';
import ProcessStartTimeBox from './Process/ProcessStartTimeBox';
import ProcessStatusBox from './Process/ProcessStatusBox';
import ProductAsMaterialResultBox from './Product/ProductAsMaterialResultBox';
import ProductResultBox from './Product/ProductResultBox';
import ProductStockLotSticker from './Product/ProductStockLotSticker';
import DashboardElementRenderingComponent from './Rendering/DashboardElementRenderingComponent';
import MMSDashboardRenderingComponent from './Rendering/MMSDashboardRenderingComponent';
import MultiUnitProdOrMatBox from './Rendering/MultiUnitProdOrMatBox';
import OnePluginDisplayRenderingComponent from './Rendering/OnePluginDisplayRenderingComponent';
import PluginDisplayRenderingComponent from './Rendering/PluginDisplayRenderingComponent';
import PluginEditRenderingComponent from './Rendering/PluginEditRenderingComponent';
import StepBox from './Step/StepBox';
import StepControlBox from './Step/StepControlBox';
import StepEmployee from './Step/StepEmployee';
import StepInfoBox from './Step/StepInfoBox';
import StepMeasurementAndMaterialDisplayBox from './Step/StepMeasurementAndMaterialDisplayBox';
import MRPBox from './MRP';

/**
 * @namespace Component/Box
 * @description Box ต่างๆ รวมถึง Panel หรือ บางอันอาจจะคล้ายๆ Card บางอันมีฟังก์ชันระดับ Call API
 * ภายใน แต่ส่วนใหญ่จะไม่มี
 */
export {
  AllMaterialUsageCard,
  BomCostBox,
  BoxAllMOMeasurementVariableBySteps,
  BoxDetailProcess,
  BoxPreferMaterial,
  BoxRemainingMaterial,
  BoxResultingFunction,
  CommentBox,
  ConveyorSketchGeneraror,
  DashboardElementRenderingComponent,
  InfoManufacturingOrder,
  ManufacturingTransactionBox,
  MaterialBomCompareBox,
  MaterialMergingDisplay,
  MaterialQuantityDisplay,
  MaterialSourceBox,
  MaterialSplittingProcessActionContainerBox,
  MaterialStockTab,
  MaterialTransactionTab,
  MaterialUsageBox,
  MeasurementVariableListBox,
  MMSDashboardRenderingComponent,
  MRPBox,
  MultiUnitProdOrMatBox,
  NameBox,
  OneMeasurementVariableBox,
  OnePluginDisplayRenderingComponent,
  PluginDisplayRenderingComponent,
  PluginEditRenderingComponent,
  ProcessActionContainerBox,
  ProcessControlBox,
  ProcessDetailBox,
  ProcessHandleProductOnlyControlBox,
  ProcessInfoBox,
  ProcessNoInfoBox,
  ProcessStartTimeBox,
  ProcessStatusBox,
  ProductAsMaterialResultBox,
  ProductBomBox,
  ProductResultBox,
  ProductStockLotSticker,
  ReportMaterialUsageTableRowElement,
  SearchBox,
  SidemenuBox,
  StepBox,
  StepControlBox,
  StepEmployee,
  StepInfoBox,
  StepMeasurementAndMaterialDisplayBox,
};

export default {
  BomCostBox,
  BoxAllMOMeasurementVariableBySteps,
  BoxDetailProcess,
  BoxPreferMaterial,
  BoxRemainingMaterial,
  BoxResultingFunction,
  CommentBox,
  InfoManufacturingOrder,
  ManufacturingTransactionBox,
  MaterialBomCompareBox,
  MaterialQuantityDisplay,
  MaterialSourceBox,
  MaterialUsageBox,
  MeasurementVariableListBox,
  MultiUnitProdOrMatBox,
  NameBox,
  OneMeasurementVariableBox,
  PluginDisplayRenderingComponent,
  PluginEditRenderingComponent,
  ProcessControlBox,
  ProcessDetailBox,
  ProcessInfoBox,
  ProcessNoInfoBox,
  ProductAsMaterialResultBox,
  ProductBomBox,
  ProductResultBox,
  SearchBox,
  StepBox,
  StepControlBox,
  StepEmployee,
  StepInfoBox,
  StepMeasurementAndMaterialDisplayBox,
  ProcessStartTimeBox,
  ProcessStatusBox,
  ConveyorSketchGeneraror,
  OnePluginDisplayRenderingComponent,
  DashboardElementRenderingComponent,
  MMSDashboardRenderingComponent,
  ReportMaterialUsageTableRowElement,
  ProcessHandleProductOnlyControlBox,
  SidemenuBox,
  ProcessActionContainerBox,
  MaterialSplittingProcessActionContainerBox,
  MaterialMergingDisplay,
  MaterialStockTab,
  MaterialTransactionTab,
  MRPBox,
  AllMaterialUsageCard,
  ProductStockLotSticker,
};
